export const MISSING_ADDRESS_PROMPT = 'Missing address info';
export const MISSING_END_COMPANY_NAME_PROMPT = 'Missing end company name';

export const NEW_NNI_TITLE = 'You are ordering a circuit against a new NNI';
export const NEW_NNI_DESCRIPTION =
  'This order will not proceed until the new NNI has been installed. If you proceed with this circuit, and have already placed your order for this NNI, supply the job reference or IDN. If you have not ordered your new NNI, contact your Neos Networks account manager.';
